import {buryPoint} from '@/Common/plugins/buried-point';
import { DEVICE_TYPE } from '@/Common/constants/device_type_const.js';
import i18n from '@pro/common/i18n/i18n';

const PERMISSION_TYPE = {
  0: '预览权限申请',
  1: '远程配置权限申请',
  2: 'ARC权限',
  3: '回放权限申请'
};
const TIME_TYPE = {
  '0': '1小时',
  '1': '2小时',
  '2': '4小时',
  '3': '8小时',
  '-1': '永久'
};
export default {
  //DDNS
  openDDNS(success) {
    success
      ? buryPoint.event({
        action: '开启DDNS-使用功能',
        eventCategory: '开启DDNS'
      })
      : buryPoint.event({
        action: '开启DDNS-DDNS配置失败',
        eventCategory: '开启DDNS'
      });
  },
  closeDDNS(success) {
    success
      ? buryPoint.event({
        action: '关闭DDNS-使用功能',
        eventCategory: '关闭DDNS'
      })
      : buryPoint.event({
        action: '关闭DDNS-DDNS配置失败',
        eventCategory: '关闭DDNS'
      });
  },
  changeDDNS(success) {
    success
      ? buryPoint.event({
        action: '修改DDNS-使用功能',
        eventCategory: '修改DDNS'
      })
      : buryPoint.event({
        action: '修改DDNS-DDNS配置失败',
        eventCategory: '修改DDNS'
      });
  },
  helpDDNS() {
    buryPoint.event({
      action: '查看端口配置帮助-使用功能',
      eventCategory: '查看端口配置帮助'
    });
  },
  addSite() {
    buryPoint.event({
      action: '创建新站点-使用功能',
      eventCategory: '创建新站点'
    });
  },
  addSiteCancel() {
    buryPoint.event({
      action: '创建新站点-取消',
      eventCategory: '创建新站点'
    });
  },
  addSiteView() {
    buryPoint.event({
      action: '创建新站点-访问',
      eventCategory: '创建新站点'
    });
  },
  hostNewSite() {
    buryPoint.event({
      action: '托管新站点-使用功能',
      eventCategory: '托管新站点'
    });
  },
  hostNewSiteView() {
    buryPoint.event({
      action: '托管新站点-访问',
      eventCategory: '托管新站点'
    });
  },
  hostNewSiteCancel() {
    buryPoint.event({
      action: '托管新站点-取消',
      eventCategory: '托管新站点'
    });
  },
  applyHostPermission() {
    buryPoint.event({
      action: '申请托管权限-使用功能',
      eventCategory: '申请托管权限'
    });
  },
  InviteSiteOwner(where) {
    const op = {
      1: '站点列表中的“邀请站点所有者”图标按钮',
      2: '站点详情页中“立即邀请”按钮',
      3: '站点详情页中“重新邀请”按钮',
      4: '站点详情页-底部引导栏'
    };
    buryPoint.event({
      action: '邀请site owner-使用功能',
      eventCategory: '邀请site owner',
      eventLabel: op[where]
    });
  },
  toDeviceTab() {
    buryPoint.event({
      action: '设备配置-查看配置',
      eventCategory: '设备配置'
    });
  },
  createLinkageRule() {
    buryPoint.event({
      action: '新建联动规则-使用功能',
      eventCategory: '新建联动规则'
    });
  },
  createLinkageRuleEntrance(where) {
    const op = {
      1: '站点列表中的按钮',
      2: '站点详情中设备卡片中的按钮',
      3: '站点详情中联动规则tab页中的按钮'
    };
    buryPoint.event({
      action: '新建联动规则-进入方式',
      eventCategory: '新建联动规则',
      eventLabel: op[where]
    });
  },
  createLinkageRuleTiming(value, eventLabel) {
    buryPoint.timing({
      name: '新建联动规则',
      value: value,
      eventCategory: '新建联动规则',
      eventLabel
    });
  },
  deleteSite(flag) {
    const op = {
      0: '未转移',
      1: '已转移未托管',
      2: '已托管',
      3: '已转移未托管',
      4: '转移中'
    };
    buryPoint.event({
      action: '删除站点-使用功能',
      eventCategory: '删除站点',
      eventLabel: op[flag]
    });
  },
  deleteSiteAccess(flag) {
    const op = {
      0: '未转移',
      1: '已转移未托管',
      2: '已托管',
      3: '已转移未托管',
      4: '转移中'
    };
    buryPoint.event({
      action: '删除站点-访问',
      eventCategory: '删除站点',
      eventLabel: op[flag]
    });
  },
  searchSiteTimes() {
    buryPoint.event({
      action: '站点搜索-使用功能',
      eventCategory: '站点搜索'
    });
  },
  assignSite() {
    buryPoint.event({
      action: '站点指派-使用功能',
      eventCategory: '站点指派'
    });
  },
  saveSiteInfo() {
    buryPoint.event({
      action: '备注站点信息-使用功能',
      eventCategory: '备注站点信息'
    });
  },
  deleteDevice() {
    buryPoint.event({
      action: '删除设备-使用功能',
      eventCategory: '删除设备'
    });
  },
  editLinkage() {
    buryPoint.event({
      action: '编辑联动规则-使用功能',
      eventCategory: '编辑联动规则'
    });
  },
  deleteLinkage() {
    buryPoint.event({
      action: '删除联动规则-使用功能',
      eventCategory: '删除联动规则'
    });
  },
  addDeviceViaLocal(flag) {
    const op = {
      1: '在站点下添加',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '局域网添加设备-使用功能',
      eventCategory: '局域网添加设备',
      eventLabel: op[flag]
    });
  },
  addDeviceViaLocalOperation(step) {
    const op = {
      2: '激活设备',
      3: '输入密码',
      4: '连接Hik-Connect',
      5: '输入验证码',
      6: '兼容性检测'
    };
    buryPoint.event({
      action: '局域网添加设备-操作步骤',
      eventCategory: '局域网添加设备',
      eventLabel: op[step]
    });
  },
  addDeviceViaLocalLoadTime(value, eventLabel) {
    buryPoint.timing({
      name: '局域网添加设备',
      value,
      eventCategory: '局域网添加设备',
      eventLabel
    });
  },
  addDeviceCountResult(count) {
    buryPoint.event({
      action: '局域网添加设备-批量添加数量',
      eventCategory: '局域网添加设备',
      eventLabel: count
    });
  },
  addDeviceSuccessResult(successNum) {
    buryPoint.event({
      action: '局域网添加设备-成功添加数量',
      eventCategory: '局域网添加设备',
      eventLabel: successNum
    });
  },
  addDeviceEnterLan(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '局域网添加设备-进入添加页',
      eventCategory: '局域网添加设备',
      eventLabel: op[flag]
    });
  },
  addDeviceViaLocalEntrance(where) {
    const op = {
      1: '站点列表中的“+”',
      2: '空白站点的详情页顶部添加按钮',
      3: '站点详情页中设备列表中的添加按钮',
      4: 'home页-常用操作',
      5: '设备添加结果页-继续添加设备',
      6: '空白站点-设备tab-add device',
      7: '空白站点--联动规则tab-add device',
      8: '空白站点--异常通知tab-add device',
      9: '空白站点--接警服务tab-add device',
      10: '空白站点--客流统计tab-add device',
      11: '空白站点--人员测温tab-add device',
      12: 'home页-右侧'
    };
    buryPoint.event({
      action: '添加设备-进入方式',
      eventCategory: '添加设备',
      eventLabel: op[where]
    });
  },
  addDeviceFeedbackTip(where) {
    const op = {
      1: '部分设备激活失败',
      2: '全部设备激活失败',
      3: '部分设备密码错误',
      4: '全部设备密码错误',
      5: '部分设备连接HC失败',
      6: '全部设备连接HC失败',
      7: '设备已被HPC或HC添加'
    };
    buryPoint.event({
      action: '局域网添加设备-添加结果',
      eventCategory: '局域网添加设备',
      eventLabel: op[where]
    });
  },
  addDeviceManuFailReason(where) {
    const op = {
      1: '网络异常',
      2: '设备已被添加',
      3: '设备不存在',
      4: '设备不在线',
      5: '设备验证码错误',
      6: '设备已被自己添加',
      7: '添加成功',
      8: '设备已被HPC或HC添加'
    };
    buryPoint.event({
      action: '手动添加Hik-Connect设备-添加结果',
      eventCategory: '手动添加Hik-Connect设备结果',
      eventLabel: op[where]
    });
  },
  addDeviceSuccessPercent(percent) {
    buryPoint.event({
      action: '局域网添加设备-成功率',
      eventCategory: '单次批量添加成功率',
      eventLabel: percent
    });
  },
  addDeviceByHand(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '手动添加Hik-Connect设备-使用功能',
      eventCategory: '手动添加Hik-Connect设备',
      eventLabel: op[flag]
    });
  },
  addDeviceByImport(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '手动添加设备-模板批量导入-使用功能',
      eventCategory: '手动添加设备-模板批量导入',
      eventLabel: op[flag]
    });
  },
  addDeviceBatchImportEnter(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '手动添加设备-模板批量导入-进入添加页',
      eventCategory: '手动添加设备-模板批量导入',
      eventLabel: op[flag]
    });
  },
  addDeviceBatchImportDownload() {
    buryPoint.event({
      action: '手动添加设备-模板批量导入-下载模板',
      eventCategory: '手动添加设备-模板批量导入'
    });
  },
  addDeviceEnterP2P(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '手动添加Hik-Connect设备-进入添加页',
      eventCategory: '手动添加Hik-Connect设备',
      eventLabel: op[flag]
    });
  },
  addDeviceByImportFailRead() {
    buryPoint.event({
      action: '手动添加设备-模板批量导入-模板解析失败',
      eventCategory: '手动添加设备-模板批量导入'
    });
  },
  addDeviceByImportSuccessNumber(number) {
    buryPoint.event({
      action: '手动添加设备-模板批量导入-添加成功数量',
      eventCategory: '手动添加设备-模板批量导入',
      eventLabel: number
    });
  },
  addDeviceByImportFailNumber(number) {
    buryPoint.event({
      action: '手动添加设备-模板批量导入-添加失败数量',
      eventCategory: '手动添加设备-模板批量导入',
      eventLabel: number
    });
  },
  addDeviceByImportTime(time, eventLabel) {
    buryPoint.timing({
      name: '手动添加设备-模板批量导入-完成时长',
      time,
      eventCategory: '手动添加设备',
      eventLabel
    });
  },
  addDeviceByHandLoadTime(value, eventLabel) {
    buryPoint.timing({
      name: '手动添加Hik-Connect设备',
      value,
      eventCategory: '手动添加Hik-Connect设备',
      eventLabel
    });
  },
  toOpenAddDeviceHelp() {
    buryPoint.event({
      action: '查看设备序列号和验证码帮助-使用功能',
      eventCategory: '查看设备序列号和验证码帮助'
    });
  },
  //局域网升级
  clickOneUpgradeWhere(where) {
    const op = {
      1: '站点详情',
      2: '健康监测-设备详情'
    };
    buryPoint.event({
      action: '单个局域网设备升级-使用功能',
      eventCategory: '单个局域网设备升级',
      eventLabel: op[where]
    });
  },
  upgradeProgress(eventLabel) {
    buryPoint.event({
      action: '局域网升级-整个升级过程',
      eventCategory: '局域网升级',
      eventLabel
    });
  },
  clickOneUpgradeTipOK() {
    buryPoint.event({
      action: '单个局域网设备升级-使用功能',
      eventCategory: '点击免责声明确定按钮'
    });
  },
  upgradeOneUpgradeResult(status, deviceSerial, errorCode, message) {
    const op = {
      2: '升级包下载失败',
      5: '升级包解压失败',
      7: '升级成功',
      8: '升级失败',
      9: '重启成功',
      10: '重启失败'
    };
    let eventLabel = `设备序列号: ${deviceSerial} === ${op[status]}`;
    if (errorCode) {
      eventLabel += ` - 错误码: ${errorCode} - 错误信息: ${message}`;
    }
    buryPoint.event({
      action: '单个局域网设备升级-升级结果',
      eventCategory: '单个局域网设备升级',
      eventLabel
    });
  },
  upgradeOneTime(value, eventLabel) {
    buryPoint.timing({
      name: '单个局域网设备升级-升级时间',
      value,
      eventCategory: '单个局域网设备升级',
      eventLabel
    });
  },
  clickManyUpgradeTipOK() {
    buryPoint.event({
      action: '批量局域网升级-使用功能',
      eventCategory: '批量局域网升级'
    });
  },
  manyUpgradeEntrance(type) {
    const op = {
      1: '站点模块-站点详情页',
      2: '批量添加设备页'
    };
    buryPoint.event({
      action: '批量局域网升级-进入方式',
      eventCategory: '批量局域网升级',
      eventLabel: op[type]
    });
  },
  choseUpgradeDeviceType(type) {
    const op = {
      0: '未知',
      1: 'IPC',
      2: 'DVR/NVR',
      3: '报警主机',
      4: '可视对讲',
      5: '门禁',
      7: '球机',
      8: '门铃'
    };
    buryPoint.event({
      action: '单个局域网设备升级-设备类型',
      eventCategory: '单个局域网设备升级',
      eventLabel: op[type]
    });
  },
  manyUpgradeNumber(number) {
    buryPoint.event({
      action: '批量局域网升级-升级数量',
      eventCategory: '批量局域网升级',
      eventLabel: number
    });
  },
  manyUpgradeSuccessNumber(number) {
    buryPoint.event({
      action: '批量局域网升级-成功升级个数',
      eventCategory: '批量局域网升级',
      eventLabel: number
    });
  },
  manyUpgradeTime(time, eventLabel) {
    buryPoint.timing({
      name: '批量局域网升级-升级时间',
      time,
      eventCategory: '批量局域网升级',
      eventLabel
    });
  },
  manyUpgradeType(type) {
    const op = {
      0: '未知',
      1: 'IPC',
      2: 'DVR/NVR',
      3: '报警主机',
      4: '可视对讲',
      5: '门禁',
      7: '球机',
      8: '门铃'
    };
    buryPoint.event({
      action: '批量升级局域网设备-设备类型',
      eventCategory: '批量升级局域网设备',
      eventLabel: op[type]
    });
  },
  upgradeDownloadPack(label) {
    buryPoint.event({
      action: '批量升级局域网-升级包下载',
      eventCategory: '批量局域网升级',
      eventLabel: label
    });
  },
  changeDeviceType(flag) {
    const op = {
      1: 'IPC',
      2: 'DVR/NVR',
      3: '报警主机',
      4: '可视对讲',
      5: '门禁',
      7: '球机',
      8: '门铃'
    };
    buryPoint.event({
      action: '设备类型无法识别，手动修改-设备类型',
      eventCategory: '设备类型无法识别，手动修改',
      eventLabel: op[flag]
    });
  },
  applyRemoteConfigPermission(where) {
    const op = {
      0: '站点模块-站点详情页',
      1: '健康监测模块-all site设备列表',
      2: '健康监测模块-站点详情-设备详情页'
    };
    buryPoint.event({
      action: '远程配置权限申请-使用功能',
      eventCategory: '远程配置权限申请',
      eventLabel: op[where]
    });
  },
  applyLiveViewPermission(where) {
    const op = {
      0: '站点模块-站点详情页',
      1: '健康监测模块-all site设备列表',
      2: '健康监测模块-站点详情-设备详情页'
    };
    buryPoint.event({
      action: '预览权限申请-使用功能',
      eventCategory: '预览权限申请',
      eventLabel: op[where]
    });
  },
  applyARCPermission(where) {
    const op = {
      0: '站点模块-站点详情页'
    };
    buryPoint.event({
      action: 'ARC权限申请-使用功能',
      eventCategory: 'ARC权限申请',
      eventLabel: op[where]
    });
  },
  applyPlaybackPermission(where) {
    const op = {
      0: '站点模块-站点详情页'
    };
    buryPoint.event({
      action: '回放权限申请-使用功能',
      eventCategory: '回放权限申请',
      eventLabel: op[where]
    });
  },
  inviteSiteOwnerPermissionApply(flag) {
    const op = {
      0: '站点管理权限',
      1: '设备配置权限',
      2: '设备预览权限',
      3: 'ARC权限',
      4: '回放权限',
      7: '设备申请开启考勤服务',
      8: '申请接入三方考勤平台权限',
      9: '申请合作服务商'
    };
    buryPoint.event({
      action: '邀请site owner-权限申请',
      eventCategory: '邀请site owner',
      eventLabel: op[flag]
    });
  },
  inviteSiteOwnerWithDescribe() {
    buryPoint.event({
      action: '邀请site owner-使用备注',
      eventCategory: '邀请site owner'
    });
  },
  inviteSiteOwnerResult(flag) {
    const op = {
      1: '已发送邀请',
      2: '该邮箱尚未注册Hik-Connect',
      3: '该手机号尚未注册Hik-Connect'
    };
    buryPoint.event({
      action: '邀请site owner-邀请结果',
      eventCategory: '邀请site owner',
      eventLabel: op[flag]
    });
  },
  singleArm(flag) {
    const op = {
      'stay': '在家布防',
      'away': '外出布防'
    };
    buryPoint.event({
      action: '布防（单个）-使用功能',
      eventCategory: '布防（单个）',
      eventLabel: op[flag]
    });
  },
  multiArm(flag) {
    const op = {
      'stay': '在家布防',
      'away': '外出布防'
    };
    buryPoint.event({
      action: '布防（批量）-使用功能',
      eventCategory: '布防（批量）',
      eventLabel: op[flag]
    });
  },
  singleFaultDetectionResult(flag) {
    const op = {
      1: '无故障',
      2: '有故障且可继续布防',
      3: '有故障无法布防'
    };
    buryPoint.event({
      action: '布防（单个）-故障检测结果',
      eventCategory: '布防（单个）',
      eventLabel: op[flag]
    });
  },
  multiFaultDetectionResult(flag) {
    const op = {
      1: '无故障',
      2: '有故障且可继续布防',
      3: '有故障无法布防'
    };
    buryPoint.event({
      action: '布防（批量）-故障检测结果',
      eventCategory: '布防（批量）',
      eventLabel: op[flag]
    });
  },
  multiArmNumber(number) {
    buryPoint.event({
      action: '布防（批量）-布防子系统数量',
      eventCategory: '布防（批量）',
      eventLabel: number
    });
  },
  singleDetectionTime(value, eventLabel) {
    buryPoint.timing({
      name: '布防（单个）-故障检测时长',
      value,
      eventCategory: '布防（单个）',
      eventLabel
    });
  },
  multiDetectionTime(value, eventLabel) {
    buryPoint.timing({
      name: '布防（批量）-故障检测时长',
      value,
      eventCategory: '布防（批量）',
      eventLabel
    });
  },
  singleArmWithFault(flag) {
    const op = {
      1: '继续布防',
      2: '取消',
      3: '60秒后自动取消'
    };
    buryPoint.event({
      action: '布防（单个）-可带故障布防反馈页中的操作',
      eventCategory: '布防（单个）',
      eventLabel: op[flag]
    });
  },
  multiArmWithFault(flag) {
    const op = {
      1: '继续布防',
      2: '取消',
      3: '60秒后自动取消'
    };
    buryPoint.event({
      action: '布防（批量）-可带故障布防反馈页中的操作',
      eventCategory: '布防（批量）',
      eventLabel: op[flag]
    });
  },
  singleArmWithFaultCanNotArm(flag) {
    const op = {
      1: '关闭按钮',
      2: '60秒后自动取消'
    };
    buryPoint.event({
      action: '布防（单个）-有故障无法布防反馈页中的操作',
      eventCategory: '布防（单个）',
      eventLabel: op[flag]
    });
  },
  multiArmWithFaultCanNotArm(flag) {
    const op = {
      1: '关闭按钮',
      2: '60秒后自动取消'
    };
    buryPoint.event({
      action: '布防（批量）-有故障无法布防反馈页中的操作',
      eventCategory: '布防（批量）',
      eventLabel: op[flag]
    });
  },
  singleDelayArmOperation(flag) {
    const op = {
      1: '立即布防',
      2: '退出',
      3: '倒计时结束后自动布防'
    };
    buryPoint.event({
      action: '布防（单个）-延迟布防倒计时页中的操作',
      eventCategory: '布防（单个）',
      eventLabel: op[flag]
    });
  },
  multiDelayArmOperation(flag) {
    const op = {
      1: '立即布防',
      2: '退出',
      3: '倒计时结束后自动布防'
    };
    buryPoint.event({
      action: '布防（批量）-延迟布防倒计时页中的操作',
      eventCategory: '布防（批量）',
      eventLabel: op[flag]
    });
  },
  singleArmResult(result) {
    const op = {
      1: '成功',
      2: '失败'
    };
    buryPoint.event({
      action: `布防（批量）-布防结果`,
      eventCategory: '布防（批量）',
      eventLabel: op[result]
    });
  },
  multiArmResult(result, number) {
    const op = {
      1: '成功',
      2: '失败'
    };
    buryPoint.event({
      action: `布防（批量）-布防${op[result]}结果`,
      eventCategory: '布防（批量）',
      eventLabel: number,
      value: number
    });
  },
  singleImmediatelyArmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '布防（单个）-成功布防时长',
      value,
      eventCategory: '布防（单个）',
      eventLabel
    });
  },
  singleFromClickArmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '布防（单个）-成功任务时长',
      value,
      eventCategory: '布防（单个）',
      eventLabel
    });
  },
  multiImmediatelyArmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '布防（批量）-成功布防时长',
      value,
      eventCategory: '布防（批量）',
      eventLabel
    });
  },
  multiFromClickArmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '布防（批量）-成功任务时长',
      value,
      eventCategory: '布防（批量）',
      eventLabel
    });
  },
  singleDisarm() {
    buryPoint.event({
      action: '撤防（单个）-使用功能',
      eventCategory: '撤防（单个）'
    });
  },
  singleDisarmResult(flag) {
    const op = {
      1: '撤防成功',
      2: '撤防失败'
    };
    buryPoint.event({
      action: '撤防（单个）-撤防结果',
      eventCategory: '撤防（单个）',
      eventLabel: op[flag]
    });
  },
  disarmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '撤防（单个）-成功任务时长',
      value,
      eventCategory: '撤防（单个）',
      eventLabel
    });
  },
  multiDisarm() {
    buryPoint.event({
      action: '撤防（批量）-使用功能',
      eventCategory: '撤防（批量）'
    });
  },
  multiDisarmResult(flag, number) {
    const op = {
      1: '成功',
      2: '失败'
    };
    buryPoint.event({
      action: `撤防（批量）-撤防${op[flag]}结果`,
      eventCategory: '撤防（批量）',
      eventLabel: number,
      value: number
    });
  },
  multiArmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '撤防（批量）-成功任务时长',
      value,
      eventCategory: '撤防（批量）',
      eventLabel
    });
  },
  singleCancelAlarm() {
    buryPoint.event({
      action: '消警（单个）-使用功能',
      eventCategory: '消警（单个）'
    });
  },
  singleCancelAlarmResult(flag) {
    const op = {
      1: '消警成功',
      2: '消警失败'
    };
    buryPoint.event({
      action: '消警（单个）-消警结果',
      eventCategory: '消警（单个）',
      eventLabel: op[flag]
    });
  },
  singleCacelAlarmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '消警（单个）-成功任务时长',
      value,
      eventCategory: '消警（单个）',
      eventLabel
    });
  },
  multiCancelAlarm() {
    buryPoint.event({
      action: '消警（批量）-使用功能',
      eventCategory: '消警（批量）'
    });
  },
  multiCancelAlarmResult(flag, number) {
    const op = {
      1: '成功',
      2: '失败'
    };
    buryPoint.event({
      action: `消警（批量）-消警${op[flag]}结果`,
      eventCategory: '消警（批量）',
      eventLabel: number,
      value: number
    });
  },
  multiCancelAlarmTiming(value, eventLabel) {
    buryPoint.timing({
      name: '消警（批量）-成功任务时长',
      value,
      eventCategory: '消警（批量）',
      eventLabel
    });
  },
  passbyDevice(flag) {
    const op = {
      1: '开启设备旁路',
      2: '关闭设备旁路'
    };
    buryPoint.event({
      action: `${op[flag]}-使用功能`,
      eventCategory: op[flag]
    });
  },
  passbyDeviceFailed(flag) {
    const op = {
      1: '开启设备旁路',
      2: '关闭设备旁路'
    };
    buryPoint.event({
      action: `${op[flag]}-${flag === 1 ? '开启' : '关闭'}失败`,
      eventCategory: op[flag]
    });
  },
  addSiteEntrance(where) {
    const op = {
      1: '站点列表',
      2: 'Home页-任务推荐banner',
      3: 'Home页-常用操作',
      4: 'Home页-首次使用请创建一个站点',
      5: 'Home-站点概览卡片',
      6: 'Home页-右侧'
    };
    buryPoint.event({
      action: '创建新站点-进入方式',
      eventCategory: '创建新站点',
      eventLabel: op[where]
    });
  },
  applyPinCode() {
    buryPoint.event({
      action: '申请PIN码-使用功能',
      eventCategory: '申请PIN码'
    });
  },
  switchDeviceLang() {
    buryPoint.event({
      action: '切换设备语言-使用功能',
      eventCategory: '切换设备语言'
    });
  },
  switchDeviceLangFailure() {
    buryPoint.event({
      action: '切换设备语言-切换失败',
      eventCategory: '切换设备语言'
    });
  },
  messageNotificationDefence(enable) {
    const op = {
      0: '关闭',
      1: '开启'
    };
    buryPoint.event({
      action: `${op[enable]}消息提醒-使用功能`,
      eventCategory: `${op[enable]}消息提醒`
    });
  },
  messageNotificationSchedule(enable) {
    const op = {
      0: '关闭',
      1: '开启'
    };
    buryPoint.event({
      action: `${op[enable]}消息提醒的时间计划-使用功能`,
      eventCategory: `${op[enable]}消息提醒的时间计划`
    });
  },
  linkageRuleStatus(enable) {
    const op = {
      0: '关闭',
      1: '开启'
    };
    buryPoint.event({
      action: `${op[enable]}联动规则-使用功能`,
      eventCategory: `${op[enable]}联动规则`
    });
  },
  templateStatus(enable) {
    const op = {
      0: '收起',
      1: '展开'
    };
    buryPoint.event({
      action: `${op[enable]}场景栏-使用功能`,
      eventCategory: `${op[enable]}场景栏`
    });
  },
  linkageRuleEntrance(flag) {
    const op = {
      1: '站点列表中的按钮',
      2: '站点详情中设备卡片中的按钮',
      3: '站点详情中联动规则tab页中的按钮',
      4: 'Home页-常用操作'
    };
    buryPoint.event({
      action: '新建自定义联动规则-进入方式',
      eventCategory: '新建自定义联动规则',
      eventLabel: op[flag]
    });
  },
  customLinkageActionsNum(num) {
    buryPoint.event({
      action: '新建自定义联动规则-联动动作数量',
      eventCategory: `新建自定义联动规则`,
      eventLabel: num,
      value: num
    });
  },
  templateLinkageType(template) {
    const op = {
      '10001': '区域入侵场景',
      '10002': '强制开门场景',
      '10003': '返回家/办公室场景',
      '10004': '外出场景',
      '10005': '访客呼叫场景',
      '10006': '周界防区告警场景'
    };
    buryPoint.event({
      action: '从场景模板新建联动规则-使用功能',
      eventCategory: '从场景模板新建联动规则',
      eventLabel: op[template],
      value: op[template]
    });
  },
  templateTiming(template, value) {
    const op = {
      '10001': '区域入侵场景',
      '10002': '强制开门场景',
      '10003': '返回家/办公室场景',
      '10004': '外出场景',
      '10005': '访客呼叫场景',
      '10006': '周界防区告警场景'
    };
    buryPoint.timing({
      action: '从场景模板新建联动规则-完成时长',
      eventCategory: op[template],
      eventLabel: value,
      value
    });
  },
  templateDetailView(template) {
    const op = {
      '10001': '区域入侵场景',
      '10002': '强制开门场景',
      '10003': '返回家/办公室场景',
      '10004': '外出场景',
      '10005': '访客呼叫场景',
      '10006': '周界防区告警场景'
    };
    buryPoint.event({
      action: '从场景模板新建联动规则-浏览场景模板详情',
      eventCategory: '从场景模板新建联动规则',
      eventLabel: op[template]
    });
  },
  templateEntrance(value) {
    const op = {
      0: '场景模板栏',
      1: '场景模板详情页左侧导航栏'
    };
    buryPoint.event({
      action: '从场景模板新建联动规则-入口位置',
      eventCategory: '从场景模板新建联动规则',
      eventLabel: op[value],
      value: op[value]
    });
  },
  openAllAbnormalEvent() {
    buryPoint.event({
      action: '全部开启异常通知-使用功能',
      eventCategory: '全部开启异常通知'
    });
  },
  closeAllAbnormalEvent() {
    buryPoint.event({
      action: '全部关闭异常通知-使用功能',
      eventCategory: '全部关闭异常通知'
    });
  },
  singleOpenAbnormalEvent(flag) {
    const op = {
      ...DEVICE_TYPE
    };
    buryPoint.event({
      action: '（单个）开启异常通知-使用功能',
      eventCategory: '（单个）开启异常通知',
      eventLabel: op[flag]
    });
  },
  singleCloseAbnormalEvent(flag) {
    const op = {
      ...DEVICE_TYPE
    };
    buryPoint.event({
      action: '（单个）关闭异常通知-使用功能',
      eventCategory: '（单个）关闭异常通知',
      eventLabel: op[flag]
    });
  },
  editDeviceAbnormalEvent() {
    buryPoint.event({
      action: '编辑设备异常事件-使用功能',
      eventCategory: '编辑设备异常事件'
    });
  },
  editChannelAbnormalEvent() {
    buryPoint.event({
      action: '编辑通道异常事件-使用功能',
      eventCategory: '编辑通道异常事件'
    });
  },
  editReceiveMode() {
    buryPoint.event({
      action: '编辑接收端-使用功能',
      eventCategory: '编辑接收端'
    });
  },
  editReceivePerson() {
    buryPoint.event({
      action: '编辑接收人-使用功能',
      eventCategory: '编辑接收人'
    });
  },
  editPeriod() {
    buryPoint.event({
      action: '编辑接受时段-使用功能',
      eventCategory: '编辑接受时段'
    });
  },
  patchSaveAdnormalRule() {
    buryPoint.event({
      action: '批量编辑异常通知-使用功能',
      eventCategory: '批量编辑异常通知'
    });
  },
  patchEditAdnormalRule() {
    buryPoint.event({
      action: '批量编辑异常通知-按钮点击',
      eventCategory: '批量编辑异常通知'
    });
  },
  patchEditAdnormalTiming(value, eventLabel) {
    buryPoint.timing({
      name: '批量编辑异常通知',
      value,
      eventCategory: '批量编辑异常通知',
      eventLabel
    });
  },
  copyAdnormalRuleSave() {
    buryPoint.event({
      action: '复制异常通知规则-使用功能',
      eventCategory: '复制异常通知规则'
    });
  },
  copyAdnormalRuleClick() {
    buryPoint.event({
      action: '复制异常通知规则-按钮点击',
      eventCategory: '复制异常通知规则'
    });
  },
  copyAdnormalTiming(value, eventLabel) {
    buryPoint.timing({
      name: '复制异常通知规则-完成时长',
      value,
      eventCategory: '复制异常通知规则',
      eventLabel
    });
  },
  cloudConfigView() {
    buryPoint.event({
      action: '云存储设置-查看配置',
      eventCategory: '云存储设置'
    });
  },
  cloudConfigEntry(entry) {
    const map = {
      1: '设备添加成功页-推荐操作',
      2: '批量设备添加成功页-设备列表',
      3: '站点详情页-设备详情',
      4: '云存储服务tab-开通云存储',
      5: '云存储服务tab-已开通服务设备的编辑'
    };
    buryPoint.event({
      action: '云存储设置-入口位置',
      eventCategory: '云存储设置',
      eventLabel: map[entry]
    });
  },
  cloudNetTestRun() {
    buryPoint.event({
      action: '云存储网络检测-使用功能',
      eventCategory: '云存储网络检测'
    });
  },
  cloudNetTestDevice(device) {
    const map = {
      9: '云存储盒子',
      2: '定制DVR'
    };
    buryPoint.event({
      action: '云存储网络检测-设备类型',
      eventCategory: '云存储网络检测',
      eventLabel: map[device]
    });
  },
  cloudNetTestSpeed({device, speed}) {
    const map = {
      9: '云存储盒子',
      2: '定制DVR'
    };
    buryPoint.event({
      action: '云存储网络检测-上行网速',
      eventCategory: '云存储网络检测',
      eventLabel: map[device],
      value: `${speed }kb/s`
    });
  },
  cloudNetTestFail() {
    buryPoint.event({
      action: '云存储网络检测-检测失败',
      eventCategory: '云存储网络检测'
    });
  },
  cloudDvrEnable() {
    buryPoint.event({
      action: '云存储DVR通路开启-使用功能',
      eventCategory: '云存储DVR通路开启'
    });
  },
  cloudDvrDisable() {
    buryPoint.event({
      action: '云存储DVR通路关闭-使用功能',
      eventCategory: '云存储DVR通路关闭'
    });
  },
  cloudActive() {
    buryPoint.event({
      action: '云存储通路激活-使用功能',
      eventCategory: '云存储通路激活'
    });
  },
  cloudActiveFail() {
    buryPoint.event({
      action: '云存储通路激活-激活失败',
      eventCategory: '云存储通路激活'
    });
  },
  cloudRenewal() {
    buryPoint.event({
      action: '云存储通路续费-使用功能',
      eventCategory: '云存储通路续费'
    });
  },
  cloudRenewalFail() {
    buryPoint.event({
      action: '云存储通路续费-激活失败',
      eventCategory: '云存储通路续费'
    });
  },
  cloudDvrVedio() {
    buryPoint.event({
      action: '云存储通路-切换视频清晰度-使用功能',
      eventCategory: '云存储通路-切换视频清晰度'
    });
  },
  cloudDvrVedioQuality(quality) {
    const map = {
      1: '流畅',
      2: '标清',
      3: '高清'
    };
    buryPoint.event({
      action: '云存储通路-切换视频清晰度-清晰度',
      eventCategory: '云存储通路-切换视频清晰度',
      eventLabel: map[quality]
    });
  },
  cloudEventConfig() {
    buryPoint.event({
      action: '云存储通路-事件配置-使用功能',
      eventCategory: '云存储通路-事件配置'
    });
  },

  viewArc() {
    buryPoint.event({
      action: '接警服务配置-查看配置',
      eventCategory: '接警服务配置'
    });
  },
  authArc() {
    buryPoint.event({
      action: '授权接警中心-使用功能',
      eventCategory: '授权接警中心'
    });
  },
  unauthArc() {
    buryPoint.event({
      action: '解除接警中心授权-使用功能',
      eventCategory: '使用功能'
    });
  },
  openDeviceArc() {
    buryPoint.event({
      action: '开启设备接警服务-使用功能',
      eventCategory: '开启设备接警服务'
    });
  },
  openDeviceArcResult(resultType, errCode) {
    let result = {
      0: '开启成功，等待站点所有者授权',
      1: '开启成功',
      2: `开启失败，原因：${ i18n.t(errCode)}`
    };
    buryPoint.event({
      action: '开启设备接警服务-开启结果',
      eventCategory: '开启设备接警服务',
      eventLabel: result[resultType]
    });
  },
  closeDeviceArc() {
    buryPoint.event({
      action: '关闭设备接警服务-使用功能',
      eventCategory: '关闭设备接警服务'
    });
  },
  closeDeviceArcResult(resultType, errCode) {
    let result = {
      0: '关闭成功',
      1: `关闭失败，原因：${ i18n.t(errCode)}`
    };
    buryPoint.event({
      action: '关闭设备接警服务-关闭结果',
      eventCategory: '关闭设备接警服务',
      eventLabel: result[resultType]
    });
  },

  permissionApplying(permissionType) {
    buryPoint.event({
      action: `${PERMISSION_TYPE[permissionType]}-使用功能`,
      eventCategory: PERMISSION_TYPE[permissionType]
    });
  },

  permissionExpireTime(permissionType, timeType) {
    buryPoint.event({
      action: `${PERMISSION_TYPE[permissionType]}-权限有效期`,
      eventCategory: PERMISSION_TYPE[permissionType],
      eventLabel: TIME_TYPE[timeType]
    });
  },

  permissionNote(permissionType) {
    buryPoint.event({
      action: `${PERMISSION_TYPE[permissionType]}-使用备注`,
      eventCategory: PERMISSION_TYPE[permissionType]
    });
  },

  applyingEntryPoint(permissionType, entryPoint) {
    const ENTRY_POINT = {
      'SITE_DETAIL': '站点模块-站点详情页',
      'HEALTH_ALL_SITE': '健康监测模块-all site设备列表',
      'HEALTH_SITE_DETAIL': '健康监测模块-站点详情页',
      'ON_PREVIEW': '设备预览',
      'ON_PLAYBACK': '设备回放',
      'PASSENGER_FLOW': '客流'
    };
    buryPoint.event({
      action: `${PERMISSION_TYPE[permissionType]}-进入方式`,
      eventCategory: PERMISSION_TYPE[permissionType],
      eventLabel: ENTRY_POINT[entryPoint]
    });
  },

  releasePermission(permissionType) {
    buryPoint.event({
      action: '释放权限-使用功能',
      eventCategory: '释放权限'
    });

    buryPoint.event({
      action: '释放权限-权限类型',
      eventCategory: '释放权限',
      eventLabel: PERMISSION_TYPE[permissionType]
    });
  },

  generateQrcodeEncrpt(flag) {
    const op = {
      1: '加密',
      2: '不加密'
    };
    buryPoint.event({
      action: '生成设备二维码-加密情况',
      eventCategory: '生成设备二维码',
      eventLabel: op[flag]
    });
  },

  saveQrcode() {
    buryPoint.event({
      action: '保存设备二维码-使用功能',
      eventCategory: '保存设备二维码'
    });
  },
  ipDomainAddManual(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '手动添加IP/domain设备-使用功能',
      eventCategory: '手动添加IP/domain设备',
      eventLabel: op[flag]
    });
  },
  ipDomainEnter(flag) {
    const op = {
      1: '在站点下添加设备',
      2: '直接添加设备'
    };
    buryPoint.event({
      action: '手动添加IP/domain设备-进入添加页',
      eventCategory: '手动添加IP/domain设备',
      eventLabel: op[flag]
    });
  },
  ipDomainAddEntry(key) {
    const op = {
      1: '站点列表中的"+"',
      2: '空白站点的详情页顶部添加按钮',
      3: '站点详情页中设备列表中的添加按钮',
      4: 'Home页-常用操作'
    };
    buryPoint.event({
      action: '手动添加IP/domain设备-进入方式',
      eventCategory: '手动添加IP/domain设备',
      eventLabel: op[key]
    });
  },
  ipDomainAddRes(key) {
    const op = {
      1: '添加成功',
      2: '用户名与密码错误',
      3: '设备已被添加'
    };
    buryPoint.event({
      action: '手动添加IP/domain设备-添加结果',
      eventCategory: '手动添加IP/domain设备',
      eventLabel: op[key]
    });
  },
  ipDomainAddTiming(value, eventLabel) {
    buryPoint.timing({
      name: '手动添加IP/domain设备-完成时间',
      value,
      eventCategory: '手动添加IP/domain设备',
      eventLabel
    });
  },
  linkageTab() {
    buryPoint.event({
      action: '联动规则配置-查看配置',
      eventCategory: '联动规则配置'
    });
  },
  abnormalTab() {
    buryPoint.event({
      action: '异常通知配置-查看配置',
      eventCategory: '异常通知配置'
    });
  },
  linkageEntrance(flag) {
    const op = {
      1: '设备添加成功页',
      2: '站点详情tab切换'
    };
    buryPoint.event({
      action: '联动规则配置-入口位置',
      eventCategory: '联动规则配置',
      eventLabel: op[flag]
    });
  },
  abnormalEntrance(flag) {
    const op = {
      1: '设备添加成功页',
      2: '站点详情tab切换'
    };
    buryPoint.event({
      action: '异常通知配置-入口位置',
      eventCategory: '异常通知配置',
      eventLabel: op[flag]
    });
  },
  inviteSiteOwnerMethod(index) {
    const method = {
      0: '系统自动发送邮件',
      1: '系统自动发送短信',
      2: '手动发送邮件',
      3: '手动发送短信'
    };

    buryPoint.event({
      action: '邀请site owner-邀请方式',
      eventCategory: '邀请site owner',
      eventLabel: method[index]
    });
  },
  ipDomainEdit() {
    buryPoint.event({
      action: '修改IP/Domain参数-使用功能',
      eventCategory: '修改IP/Domain参数'
    });
  },

  cloudStorageTabView() {
    buryPoint.event({
      action: '站点云存储配置-查看配置',
      eventCategory: '站点云存储配置'
    });
  },
  cloudStorageTabEntrance(flag) {
    const op = {
      1: '站点详情页tab切换',
      2: '服务购买成功页'
    };
    buryPoint.event({
      action: '站点云存储配置-入口位置',
      eventCategory: '站点云存储配置',
      eventLabel: op[flag]
    });
  },
  temperatureTabView() {
    buryPoint.event({
      action: '站点人员测温-查看配置',
      eventCategory: '站点人员测温'
    });
  },
  temperatureEntrance(flag) {
    const op = {
      1: '站点详情页tab切换',
      2: '人员测温服务购买成功页'
    };
    buryPoint.event({
      action: '站点人员测温-入口位置',
      eventCategory: '站点人员测温',
      eventLabel: op[flag]
    });
  },
  temperatureAllEnable() {
    buryPoint.event({
      action: '全部开启测温-使用功能',
      eventCategory: '全部开启测温'
    });
  },
  temperatureAllDisable() {
    buryPoint.event({
      action: '全部关闭测温-使用功能',
      eventCategory: '全部关闭测温'
    });
  },
  temperatureSingleEnable() {
    buryPoint.event({
      action: '(单个)开启测温-使用功能',
      eventCategory: '(单个)开启测温'
    });
  },
  temperatureSingleDisable() {
    buryPoint.event({
      action: '(单个)关闭测温-使用功能',
      eventCategory: '(单个)关闭测温'
    });
  },
  temperatureConfig() {
    buryPoint.event({
      action: '设备测温配置-使用功能',
      eventCategory: '设备测温配置'
    });
  },
  temperatureServiceOpen() {
    buryPoint.event({
      action: '开通人员测温服务-使用功能',
      eventCategory: '开通人员测温服务'
    });
  },
  temperatureServiceTryout() {
    buryPoint.event({
      action: '试用人员测温服务-使用功能',
      eventCategory: '试用人员测温服务'
    });
  },
  temperatureServiceRenew() {
    buryPoint.event({
      action: '延长人员测温服务-使用功能',
      eventCategory: '延长人员测温服务'
    });
  },
  temperatureServiceRenewEntrance(flag) {
    const op = {
      1: '站点详情页-人员测温tab页',
      2: '我的服务-人员测温详情tab页',
      3: '增值服务到期提醒弹窗'
    };
    buryPoint.event({
      action: '延长人员测温服务-入口位置',
      eventCategory: '延长人员测温服务',
      eventLabel: op[flag]
    });
  },
  viewMaintenanceManage() {
    buryPoint.event({
      action: '运维服务激活-进入激活页面',
      eventCategory: '运维服务激活'
    });
  },
  maintenanceManagerEntrance(flag) {
    const op = {
      1: '健康监测-allsite"无设备启用运维功能，无健康状态监测“',
      2: '设备添加结果页-运维设备超出容量提示',
      3: '我的增值服务管理',
      4: '设备详情页-异常通知tab-运维管理（该站点设备未加入运维包）',
      5: '运维包购买成功页-立即使用运维服务',
      6: '健康检测-无设备启用运维功能',
      7: '设备健康状态空白页-运维管理',
      8: '我的服务-所有服务-运维服务激活',
      9: '我的服务-健康监测包-运维功能激活',
      10: '站点-设备tab-运维功能未开启提示-运维服务激活'
    };
    buryPoint.event({
      action: '运维服务激活-入口位置',
      eventCategory: '运维服务激活',
      eventLabel: op[flag]
    });
  },
  clickDeviceMaintenaace() {
    buryPoint.event({
      action: '运维服务激活-激活',
      eventLabel: '运维服务激活'
    });
  },
  passengerFlowTabView() {
    buryPoint.event({
      action: '站点客流统计-查看配置',
      eventCategory: '站点客流统计'
    });
  },
  passengerFlowTabEntrance(flag) {
    const op = {
      1: '站点详情页tab切换',
      2: '站点客流服务购买成功页'
    };
    buryPoint.event({
      action: '站点客流统计-入口位置',
      eventCategory: '站点客流统计',
      eventLabel: op[flag]
    });
  },
  enableSinglePassengerFlow() {
    buryPoint.event({
      action: '（单个）开启客流统计-使用功能',
      eventCategory: '（单个）开启客流统计'
    });
  },
  disableSinglePassengerFlow() {
    buryPoint.event({
      action: '（单个）关闭客流统计-使用功能',
      eventCategory: '（单个）关闭客流统计'
    });
  },
  enableAllPassengerFlow() {
    buryPoint.event({
      action: '全部开启客流统计-使用功能',
      eventCategory: '全部开启客流统计'
    });
  },
  disableAllPassengerFlow() {
    buryPoint.event({
      action: '全部关闭客流统计-使用功能',
      eventCategory: '全部关闭客流统计'
    });
  },
  receiveCloudServiceGift() {
    buryPoint.event({
      action: '领取云存储赠送服务-使用功能',
      eventCategory: '领取云存储赠送服务'
    });
  },
  cloudServiceGiftEntrance(flag) {
    const op = {
      1: '云存储盒子添加结果页',
      2: '云存储服务激活弹窗'
    };
    buryPoint.event({
      action: '领取云存储赠送服务-入口位置',
      eventCategory: '领取云存储赠送服务',
      eventLabel: op[flag]
    });
  },
  cloudServiceGiftResult(flag, errorCode) {
    const op = {
      1: '领取成功',
      2: `领取失败-${ errorCode}`
    };
    buryPoint.event({
      action: '领取云存储赠送服务-领取结果',
      eventCategory: '领取云存储赠送服务',
      eventLabel: op[flag]
    });
  },
  cloudBoxAddChannel() {
    buryPoint.event({
      action: '云存储盒子添加通路-使用功能',
      eventCategory: '云存储盒子添加通路'
    });
  },
  cloudBoxChannelEdit() {
    buryPoint.event({
      action: '云存储盒子修改通路-使用功能',
      eventCategory: '云存储盒子修改通路'
    });
  },
  cloudBoxChannelDelete() {
    buryPoint.event({
      action: '云存储盒子删除通路-使用功能',
      eventCategory: '云存储盒子删除通路'
    });
  },
  unbindDeviceClickTimes() {
    buryPoint.event({
      action: '设备解绑-使用功能',
      eventCategory: '设备解绑'
    });
  },
  unbindDeviceResult(resultType, errCode) {
    let result = {
      1: '解绑成功',
      2: `解绑失败，原因：${ errCode}`
    };
    buryPoint.event({
      action: '设备解绑-解绑结果',
      eventCategory: '设备解绑',
      eventLabel: result[resultType]
    });
  },
  changeRightShow(type) {
    const op = {
      1: '收起',
      2: '展开'
    };
    buryPoint.event({
      action: '站点详情侧边面板收起/展开-使用功能',
      eventCategory: '站点详情侧边面板收起/展开',
      eventLabel: op[type]
    });
  },
  attendanceTabView() {
    buryPoint.event({
      action: '站点云考勤-查看配置',
      eventCategory: '站点云考勤'
    });
  },
  addAttendanceSystem() {
    buryPoint.event({
      action: '添加考勤系统-使用功能',
      eventCategory: '添加考勤系统'
    });
  },
  deleteAttendanceSystem() {
    buryPoint.event({
      action: '删除考勤系统-使用功能',
      eventCategory: '删除考勤系统'
    });
  },
  editAttendanceSystem() {
    buryPoint.event({
      action: '编辑考勤系统-使用功能',
      eventCategory: '编辑考勤系统'
    });
  },
  attendanceAuthTipShow() {
    buryPoint.event({
      action: '编辑考勤系统-授权提醒',
      eventCategory: '编辑考勤系统'
    });
  },
  howtoUseAttendanceSystemGuide() {
    buryPoint.event({
      eventCategory: '考勤系统如何使用',
      action: '考勤系统如何使用-出现引导'
    });
  },
  howtoUseAttendanceSystemGoAndSee() {
    buryPoint.event({
      eventCategory: '考勤系统如何使用',
      action: '考勤系统如何使用-前往查看'
    });
  },
  directAddDeviceDirectEntrance(flag) {
    const op = {
      1: 'Home页-首次使用请创建一个站点',
      2: 'Home-站点概览卡片',
      3: '站点列表',
      4: '设备批量配置-完成弹窗-前往添加设备',
      5: '定时发送报表空白页-添加设备',
      6: '服务市场-免费功能卡片-添加设备',
      7: '服务市场-健康监测包（限时免费）-添加设备',
      8: '运维服务激活-添加设备'
    };
    buryPoint.event({
      action: '直接添加设备-进入方式',
      eventCategory: '直接添加设备',
      eventLabel: op[flag]
    });
  },
  addDeviceLanSiteChoose(flag) {
    const op = {
      1: '无站点选择项',
      2: '新建站点',
      3: '添加到已有站点'
    };
    buryPoint.event({
      action: '局域网添加设备-选择站点',
      eventCategory: '局域网添加设备',
      eventLabel: op[flag]
    });
  },
  addDeviceActivateDeviceCompleted() { // 记录激活设备步骤页中“下一步”按钮的点击，统计完成频次
    buryPoint.event({
      eventCategory: '局域网添加设备',
      action: '局域网添加设备-1.完成设备激活'
    });
  },
  addDeviceEnterPasswordCompleted() { // 记录输入密码步骤页中“下一步"按钮的点击，统计完成频次
    buryPoint.event({
      eventCategory: '局域网添加设备',
      action: '局域网添加设备-2.完成输入密码'
    });
  },
  addDeviceEnterCodeCompleted() { // 记录输入验证码页中“下一步"按钮的点击，统计完成频次
    buryPoint.event({
      eventCategory: '局域网添加设备',
      action: '局域网添加设备-3.完成输入验证码'
    });
  },
  addDeviceCompatibilityMonitorCompleted() { // 记录兼容检测页中“添加"或“添加并升级”按钮的点击，统计完成频次
    buryPoint.event({
      eventCategory: '局域网添加设备',
      action: '局域网添加设备-4.完成兼容性检测'
    });
  },
  addDeviceP2PSiteChoose(flag) {
    const op = {
      1: '无站点选择项',
      2: '新建站点',
      3: '添加到已有站点'
    };
    buryPoint.event({
      action: '手动添加Hik-Connect设备-选择站点',
      eventCategory: '手动添加Hik-Connect设备',
      eventLabel: op[flag]
    });
  },
  addDeviceIpDomainSiteChoose(flag) {
    const op = {
      1: '无站点选择项',
      2: '新建站点',
      3: '添加到已有站点'
    };
    buryPoint.event({
      action: '手动添加IP/domain设备-选择站点',
      eventCategory: '手动添加IP/domain设备',
      eventLabel: op[flag]
    });
  },
  addDeviceByImportSiteChoose(flag) {
    const op = {
      1: '无站点选择项',
      2: '新建站点',
      3: '添加到已有站点'
    };
    buryPoint.event({
      action: '手动添加设备-模板批量导入-选择站点',
      eventCategory: '手动添加设备-模板批量导入',
      eventLabel: op[flag]
    });
  },
  cancelInvite() {
    buryPoint.event({
      action: '取消站点托管-访问',
      eventCategory: '取消站点托管'
    });
  },
  cancelInviteSure() {
    buryPoint.event({
      action: '取消站点托管-使用功能',
      eventCategory: '取消站点托管'
    });
  },
  applyThirdAttendancePermission() {
    buryPoint.event({
      action: '三方考勤平台接入权限申请-使用功能',
      eventCategory: '三方考勤平台接入权限申请'
    });
  },
  applyThirdAttendancePermissionWithRemark() {
    buryPoint.event({
      action: '三方考勤平台接入权限申请-使用备注',
      eventCategory: '三方考勤平台接入权限申请'
    });
  },
  deviceResetPasswordSiteCard() {
    buryPoint.event({
      action: '设备密码重置-使用功能',
      eventCategory: '设备密码重置'
    });
  },
  deviceResetPasswordSuccessSiteCard() {
    buryPoint.event({
      action: '设备密码重置-重置结果',
      eventCategory: '设备密码重置'
    });
  },
  offlineDeviceSearchCount() {
    buryPoint.event({
      action: '设备离线的站点搜索',
      eventCategory: '站点搜索'
    });
  },
  operationAndMaintenanceServiceGuidance(flag) {
    const op = {
      1: '站点列表-运维服务',
      2: '站点详情页-运维服务',
      3: '设备迁移弹窗-运维服务',
      4: '设备迁移弹窗-链接'
    };
    buryPoint.event({
      action: '运维服务引导（hc主动托管设备功能）-查看功能介绍',
      eventCategory: '运维服务引导（hc主动托管设备功能）',
      eventLabel: op[flag]
    });
  },
  hostingResults(flag, err) {
    const op = {
      1: '设备已完成托管',
      2: '申请已过期',
      3: '失败：网络异常',
      4: '申请已失效',
      5: `失败：${err}`
    };
    buryPoint.event({
      action: '运维服务引导（hc主动托管设备功能）-托管结果',
      eventCategory: '运维服务引导（hc主动托管设备功能）',
      eventLabel: op[flag]
    });
  },
  siteShareFirstTime(flag) {
    const op = {
      1: '站点详情页',
      2: '站点列表'
    };
    buryPoint.event({
      action: '站点分享-进入站点（首次）分享',
      eventCategory: '站点分享',
      eventLabel: op[flag]
    });
  },
  siteShareCollapse() {
    buryPoint.event({
      action: '站点分享-手动展开站点分享介绍',
      eventCategory: '站点分享'
    });
  },
  sendShareRequest() {
    buryPoint.event({
      action: '站点分享-发送分享请求',
      eventCategory: '站点分享'
    });
  },
  resendShareRequestToEnduser(flag) {
    const op = {
      1: '等待终端用户授权',
      2: '终端用户已拒绝'
    };
    buryPoint.event({
      action: '站点分享-重新向终端用户发送授权请求',
      eventCategory: '站点分享',
      eventLabel: op[flag]
    });
  },
  resendShareRequestToCooperation(flag) {
    const op = {
      1: '等待合作商授权',
      2: '合作商已拒绝'
    };
    buryPoint.event({
      action: '站点分享-重新向合作商发送分享申请',
      eventCategory: '站点分享',
      eventLabel: op[flag]
    });
  },
  modifyShareRequest() {
    buryPoint.event({
      action: '站点分享-修改权限',
      eventCategory: '站点分享'
    });
  },
  cancelSiteShare() {
    buryPoint.event({
      action: '站点分享-取消分享',
      eventCategory: '站点分享'
    });
  },
  freeActivationAttendanceSystem() {
    buryPoint.event({
      action: '云考勤系统免费激活-免费激活',
      eventCategory: '云考勤系统免费激活'
    });
  },
  confirmActivationAttendanceSystem() {
    buryPoint.event({
      action: '云考勤系统免费激活-确认激活',
      eventCategory: '云考勤系统免费激活'
    });
  },
  activationAttendanceSystemSuccess() {
    buryPoint.event({
      action: '云考勤系统免费激活-激活成功',
      eventCategory: '云考勤系统免费激活'
    });
  },
  activationAttendanceSystemFailed() {
    buryPoint.event({
      action: '云考勤系统免费激活-激活失败',
      eventCategory: '云考勤系统免费激活'
    });
  },
  extendRenewAttenddancePopup() {
    buryPoint.event({
      action: '云考勤系统扩容/续费-出现弹窗',
      eventCategory: '云考勤系统免费激活'
    });
  },
  extendRenewFastChoice(flag) {
    const op = {
      1: '考勤人数',
      2: '考勤时长'
    };
    buryPoint.event({
      action: '云考勤系统扩容/续费-快速选择',
      eventCategory: '云考勤系统免费激活',
      eventLabel: op[flag]
    });
  },
  handleMenuBottomBtn(flag) {
    const op = {
      1: '添加设备',
      2: '重置设备密码'
    };
    buryPoint.event({
      eventCategory: '站点-侧边菜单',
      action: '底部按钮点击',
      eventLabel: op[flag]
    });
  }
};
